import React from 'react';
import { getClassNames } from '../../utils';
import './Loader.css';
import withTheme from '../../hocs/withTheme';

function Loader({ large = false, light = false, negative = false, small = false }) {
    const className = getClassNames(
        'Loader',
        { 'Loader-large': large },
        { 'Loader-small': small },
        { 'Loader-light': light },
        { 'Loader-negative': negative },
    );

    return (
        <div className="Loader-wrapper">
            <div className={className}>
                <div className="Loader-circle" />
            </div>
        </div>
    );
}


export default withTheme(Loader);
